import { createApp } from 'vue'
import { setupStore } from '@/stores'
import i18n from '@/lang'
import './style.css'
import App from './App.vue'
import router from './router'
import '@/fonts/iconfont/iconfont.js'
import '@/fonts/iconfont/iconfont.css';
import directives from '@/directives';
import { isWxMiniRes, timeJudge } from '@/utils'
import componentsRegistrar from '@/components/globalComponentsConfig'
import 'vant/lib/index.css'
import('@/utils/flexible.js')

const app = createApp(App)
app.config.globalProperties.$timeJudge = timeJudge
app.use(i18n)
app.use(setupStore)
app.use(router)
app.use(directives)
app.use(componentsRegistrar)

app.config.globalProperties.$isWxMiniRes = isWxMiniRes
app.mount('#app')
